
import {
  computed,
  watch,
  inject,
  onMounted,
  reactive,
  ref,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import useBreakpoints from "@/services/Breakpoints";
import { Hotel } from "@/vue-core/models/Hotel.model";
import { loaderDone, loaderStart } from "@/services/Loader";
export default {
  setup() {
    const drawer = ref(false);
    const { type } = useBreakpoints();
    const adultSelected = ref(1);
    const childSelected = ref(0);
    const isHidden = ref(false);
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const hotelID = route.params.hotelID;
    const eventID = route.params.eventID;
    const rangeDates = ref({
      start: null,
      end: null,
    });
    const page = computed(() => {
      return {
        month: validDates.start.getMonth() + 1,
        year: validDates.start.getFullYear(),
      };
    });
    const validButtonFilter = computed(() => {
      if (
        rangeDates.value.start !== null &&
        rangeDates.value.end !== null &&
        (adultSelected.value > 0 || childSelected.value > 0)
      ) {
        return false;
      }
      return true;
    });
    const validDates = reactive({ start: new Date(), end: new Date() });
    const filterClassRoomFilter = computed(() => {
      if (type.value === "sm") return "room-filter-xs";
      return "room-filter-xl";
    });
    const disabledEndDate = (time: Date) => {
      return (
        time.getTime() < validDates.start.getTime() ||
        time.getTime() > validDates.end.getTime() ||
        new Date(rangeDates.value.start!).getTime() >= time.getTime()
      );
    };
    const disabledStartDate = (time: Date) => {
      return (
        time.getTime() < validDates.start.getTime() ||
        time.getTime() > validDates.end.getTime()
      );
    };
    onMounted(async () => {
      const emitter: any = inject("emitter");
      emitter.on("toggleRoomFilter", (value) => {
        drawer.value = value;
      });
      const today = new Date();
      loaderStart();
      const hotelData: Hotel = await store.dispatch("user/getHotelDetails", {
        eventID: eventID,
        hotelID: hotelID,
      });
      loaderDone();
      const eventStartDate = hotelData.startDate.toDate();
      const startDate = new Date(eventStartDate.setHours(0, 0, 0, 0));
      validDates.start = startDate;
      const eventEndDate = hotelData.endDate.toDate();
      const endDate = new Date(eventEndDate.setHours(0, 0, 0, 0));
      validDates.end = endDate;
      if (today > startDate) {
        validDates.start = today;
      }
    });
    const applyFilter = async () => {
      if (!rangeDates.value.start && !rangeDates.value.end) return;
      const dateEnd = new Date(rangeDates.value.end!);
      const dateStart = new Date(rangeDates.value.start!);
      const rangeEnd = dateEnd > dateStart ? dateEnd : dateStart;
      const rangeStart = dateStart < dateEnd ? dateStart : dateEnd;
      const toDate = new Date(
        rangeEnd.getTime() - rangeEnd.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
      const fromDate = new Date(
        rangeStart.getTime() - rangeStart.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
      drawer.value = !drawer.value;
      router.push({
        name: "HotelFilterList",
        params: { eventID, hotelID },
        query: {
          adultSelected: adultSelected.value,
          childSelected: childSelected.value,
          fromDate,
          toDate,
        },
      });
    };
    return {
      drawer,
      adultSelected,
      childSelected,
      rangeDates,
      validButtonFilter,
      isHidden,
      validDates,
      disabledEndDate,
      disabledStartDate,
      applyFilter,
      type,
      filterClassRoomFilter,
      page,
    };
  },
  props: ["hotelDetails"],
};
